import { Fragment, memo } from 'react';
import classnames from 'classnames';
import { func, number, shape, string } from 'prop-types';

import { Button, EntityCard } from '~/elements';
import { getTimeSlotDescription } from '~/routes/utils/helpers';
import { replaceWithNonbreakableSpaces } from '~/utils';
import { triggerEditPageClickedAnalytics } from '~/analytics/analytics.listener';

import styles from '../../../../../components/treatment-list-details/TreatmentListDetails.scss';

export const TreatmentDetails = memo(({ treatment, editModeConfig, history }) => (
  <Fragment>
    <figure className={classnames(styles.TreatmentCategoryThumbnail)}>
      <span
        style={{
          backgroundImage: `url(${treatment.treatmentCategoryImageSrc})`,
        }}
        data-testid="TreatmentCategoryThumbnail"
      />
    </figure>
    <div className={classnames(styles.TreatmentMeta)}>
      <EntityCard title={treatment.name} className={styles.TreatmentCard}>
        <div className={styles.TimeSlotDescription} data-testid="TimeSlotDescription">
          {getTimeSlotDescription(treatment.dateSlot, treatment.timeSlot, '•')}{' '}
          {replaceWithNonbreakableSpaces(`with ${treatment.partner.name}`)}
        </div>
        <Button
          view="underlined"
          onClick={() => {
            triggerEditPageClickedAnalytics('appointments');
            history.pushWithToken({
              pathname: `/${editModeConfig.firstEditPagePath}`,
              appointmentTypeIdBeingEdited: treatment.id,
            });
          }}
          data-testid="EditButton"
        >
          Edit time slot
        </Button>
        <div className={styles.TreatmentPrice} data-testid="TreatmentPrice">
          {treatment.price}
        </div>
      </EntityCard>
    </div>
  </Fragment>
));

TreatmentDetails.propTypes = {
  treatment: shape({
    name: string.isRequired,
    price: string.isRequired,
    dateSlot: string.isRequired,
    timeSlot: shape({
      from: number.isRequired,
      eventId: string,
    }).isRequired,
    partner: shape({
      id: string,
      name: string,
    }).isRequired,
    treatmentCategoryImageSrc: string,
  }).isRequired,
  history: shape({
    pushWithToken: func.isRequired,
  }).isRequired,
  editModeConfig: shape({
    firstEditPagePath: string,
  }).isRequired,
};
